__turbopack_context__.v({
  "caption": "_CeSFW_caption",
  "content": "_CeSFW_content",
  "head": "_CeSFW_head",
  "headContainer": "_CeSFW_headContainer",
  "parentContainer": "_CeSFW_parentContainer",
  "root": "_CeSFW_root",
});
